<template>
    <div class="workorderDetail">
        <div class="baseinfo box">
            <div class="info-header flex-between">
                <div>工单：<span @dblclick="$utils.dblclickCopy">{{ detailInfo.workNo }}</span></div>

                <el-dropdown @command="handleCommand">
                    <el-button>客诉处置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="followup">客诉回访</el-dropdown-item>
                        <el-dropdown-item command="reassign">改派车辆</el-dropdown-item>
                        <el-dropdown-item command="ban">封禁司机</el-dropdown-item>
                        <el-dropdown-item command="cancel">取消订单</el-dropdown-item>
                        <el-dropdown-item command="refund">发起退款</el-dropdown-item>
                        <el-dropdown-item command="close">关闭工单</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="客诉类型">{{ detailInfo.categoryName || "-" }}</el-descriptions-item>
                <el-descriptions-item label="工单状态">
                    <el-tag :type="detailInfo.status | filterConst('WORKORDERSTATUS', 'type')">{{ detailInfo.status |
                        filterConst('WORKORDERSTATUS') }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="紧急程度">
                    <span v-for="item in $const.URGENCYLIST.filter(item => item.value == detailInfo.priority)"
                        :key="item.value" :style="{ color: item.color }">{{ item.label }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="客诉内容">
                    <workOrderInfo :detailInfo="detailInfo"></workOrderInfo>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="机构名称">{{ organizationName || "-" }}</el-descriptions-item>
                <el-descriptions-item label="订单来源">{{ detailInfo.channelAlias | filterConst('HITCHHIKINGCHANNEL')
                }}</el-descriptions-item>
                <el-descriptions-item label="创建人">{{ detailInfo.operator || "-" }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ detailInfo.created | filterTime }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ detailInfo.updated | filterTime }}</el-descriptions-item>
            </el-descriptions>
        </div>

        <el-tabs v-model="activeName" class="box driver-tabs">
            <el-tab-pane label="工单处置" name="handle">
                <workOrderRecord ref="workOrderRecord" :id="detailInfo.id" v-if="activeName == 'handle'">
                </workOrderRecord>
            </el-tab-pane>
            <el-tab-pane label="订单信息" name="order">
                <orderDetail v-if="activeName == 'order'" :orderInfo="orderInfo"></orderDetail>
            </el-tab-pane>
            <!-- 跟踪记录 -->
            <el-tab-pane label="订单跟踪" name="map">
                <orderRecord :orderId="orderInfo.id" v-if="activeName == 'map'"></orderRecord>
            </el-tab-pane>
            <!-- 行程录音 -->
            <el-tab-pane label="行程录音" name="audio">
                <orderAudio :rowData="orderInfo" v-if="activeName == 'audio'"></orderAudio>
            </el-tab-pane>
            <!-- 聊天记录 -->
            <el-tab-pane label="聊天记录" name="chat" style="width: 500px;">
                <div class="blueInfo">
                    * 以下为该订单乘客与司机通过司机端App内的聊天工具的建联记录
                </div>
                <orderChat :orderId="orderInfo.id" v-if="activeName == 'chat'"></orderChat>
            </el-tab-pane>
        </el-tabs>

        <orderReassign v-if="showReassign" :show="showReassign" :orderId="orderInfo.id" :loading="loading"
            @assign="assignFn" @close="handClose"></orderReassign>

        <driverBan @submitBan="submitBan" :driverId="orderInfo.driverId" :show="showBan" @close="handClose"
            :loading="banLoading"></driverBan>

        <el-dialog title="客诉回访" :visible.sync="followupDialogShow" width="600px" :before-close="handleClose"
            destroy-on-close :close-on-click-modal="false">
            <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">

                <el-form-item label="回访对象" prop="feedbackType">
                    <el-radio-group v-model="formData.feedbackType">
                        <el-radio :label="1">乘客</el-radio>
                        <el-radio :label="2">司机</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="回访内容" prop="feedbackContent">
                    <el-input type="textarea" v-model="formData.feedbackContent" :maxlength="200" show-word-limit
                        rows="4" placeholder="请输入" />
                </el-form-item>

                <el-form-item label="附件内容">
                    <upload_pdfs :max="5" :multiple="true" accept=".png,.jpg,.jpeg" :urls.sync="formData.feedbackFile"
                        @isUpLoad="isUpLoad"> </upload_pdfs>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">提 交</el-button>
            </div>
        </el-dialog>

        <el-dialog title="取消订单" :before-close="handClose" :visible.sync="showCancel" destroy-on-close
            :wrapperClosable="false" width="500px">
            <hitchhikingCancel @handClose="handClose" :rowData="orderInfo" :workId="detailInfo.id"></hitchhikingCancel>
        </el-dialog>

        <el-dialog title="订单退款" :before-close="handClose" :visible.sync="showRefund" destroy-on-close
            :wrapperClosable="false" width="500px">
            <el-form :model="refundForm" :rules="refundRules" ref="refundFormRef" label-width="100px">
                <!-- 退款类型 -->
                <el-form-item label="退款类型" prop="refundType" required>
                    <el-radio-group v-model="refundForm.refundType">
                        <el-radio :label="1">全额退款</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 退款金额 -->
                <el-form-item label="退款金额">
                    <span>{{ refundForm.refundAmount }}元</span>
                </el-form-item>
                <!-- 退款原因 -->
                <el-form-item label="退款原因" prop="refundReason" required>
                    <el-input
                        type="textarea"
                        v-model="refundForm.refundReason"
                        :maxlength="100"
                        show-word-limit
                        rows="3"
                        placeholder="请输入100字内的原因"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handClose">取消</el-button>
                <el-button type="primary" @click="handleRefundSubmit" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import orderRecord from './components/orderRecord.vue';
import orderChat from './components/orderChat.vue';
import orderAudio from './components/orderAudio.vue';
import orderDetail from "./components/orderDetail.vue";
import workOrderRecord from "./components/workOrderRecord.vue";
import workOrderInfo from "./components/workOrderInfo.vue";
import orderReassign from './components/orderReassign.vue';
import driverBan from '@/page/resource/driver/components/driverBan.vue';
import upload_pdfs from "@/components/pdf/upload_pdfs";
import hitchhikingCancel from "./components/hitchhikingCancel.vue";
export default {
    name: "workorderDetail",
    components: {
        orderDetail,
        workOrderRecord,
        workOrderInfo,
        orderReassign,
        driverBan,
        orderRecord,
        orderChat,
        orderAudio,
        upload_pdfs,
        hitchhikingCancel
    },
    props: {},
    data() {
        return {
            id: this.$route.query.id,
            detailInfo: {},
            organizationName: '',
            activeName: 'handle',
            handleList: [],
            orderInfo: {},
            showReassign: false,
            showBan: false,
            loading: false,
            banLoading: false,
            followupDialogShow: false,
            rules: {
                feedbackType: [
                    {
                        required: true,
                        message: '请选择回访对象',
                        trigger: 'change'
                    }
                ],
                feedbackContent: [
                    {
                        required: true,
                        message: '请输入回访内容',
                        trigger: 'blur'
                    }
                ]
            },
            formData: {
                feedbackType: 1,
                feedbackContent: null,
                feedbackFile: null,
            },
            showCancel: false,
            refundForm: {
                refundType: 1,
                refundAmount: null,
                refundReason: null,
            },
            refundRules: {
                refundType: [
                    {
                        required: true,
                        message: '请选择退款类型',
                        trigger: 'change'
                    }
                ],
                refundReason: [
                    {
                        required: true,
                        message: '请输入退款原因',
                        trigger: 'blur'
                    }
                ]
            },
            showRefund: false
        };
    },
    /**
     * 组件创建时初始化数据
     * @returns {void}
     */
    created() {
        this.getDetailInfo();
    },
    methods: {
        isUpLoad(isUpLoad) {
            this.loading = isUpLoad
        },
        handleClose() {
            this.$refs.formRef.resetFields()
            this.followupDialogShow = false
        },
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    let url = "/api/v1/manage/hitchRide/work/handling";
                    let params = {
                        workId: this.detailInfo.id,
                        handlingMethod: 4,
                        feedbackContent: this.formData.feedbackContent,
                        feedbackFile: this.formData.feedbackFile?.map(item => item.url).join(',') || null,
                        feedbackType: this.formData.feedbackType,
                    };
                    let { code, data } = await this.$axios.post(url, params)
                    if (code === 1) {
                        this.$message.success('提交成功');
                        this.handleClose();
                        this.ishandle()
                    }
                    this.loading = false
                }
            })
        },
        // 工单详情
        async getDetailInfo() {
            this.loading = true
            let url = `/api/v1/manage/hitchRide/work/info/${this.id}`
            let { code, data } = await this.$axios.get(url)
            if (code == 1) {
                this.detailInfo = data
                this.organizationName = await this.getOrgName(data.organizationId)
                this.getOrderInfo()
            }
            this.loading = false
        },
        async handleCommand(command) {
            switch (command) {
                case 'followup':
                    this.followupDialogShow = true
                    break
                case 'reassign':
                    if (this.orderInfo.status != 10) {
                        this.$message.error('仅待开始订单才可改派车辆');
                        return;
                    }
                    this.showReassign = true
                    break
                case 'ban':
                    if (!this.orderInfo.driverId) {
                        this.$message.error('当前订单不存在司机信息，无法封禁');
                        return;
                    }
                    let url = `/api/v1/manage/driver/${this.orderInfo.driverId}`
                    let { code, data } = await this.$axios.get(url)
                    if (code == 1) {
                        if (data.isEnable == 2) {
                            this.$message.error('当前司机已处于封禁状态');
                            return;
                        }
                    }
                    this.showBan = true;
                    break
                case 'cancel':
                    this.showCancel = true
                    break
                case 'refund':
                    this.showRefund = true
                    break
                case 'close':
                    this.closeWorkOrder()
                    break
            }
        },
        handClose() {
            this.showBan = false;
            this.showReassign = false;
            this.showCancel = false;
            this.showRefund = false;
            this.ishandle()
        },
        ishandle() {
            if (this.activeName == 'handle') {
                this.$refs.workOrderRecord.getHandleList()
            }
        },
        async submitBan(params) {
            this.banLoading = true;
            let url = "/api/v1/manage/hitchRide/work/handling";
            let data = await this.$axios.post(url, {
                workId: this.detailInfo.id,
                driverId: this.orderInfo.driverId,
                handlingMethod: 2,
                disableType: params.disableType,
                disableDays: params.disableDays,
                disableReason: params.disableReason
            });
            if (data && data.code === 1) {
                this.$message.success("司机已封禁");
                this.handClose();
                this.ishandle()
            }
            this.banLoading = false;
        },
        async assignFn(row) {
            this.loading = true;
            const url = "/api/v1/manage/hitchRide/work/handling"
            const params = {
                workId: this.detailInfo.id,
                handlingMethod: 1,
                orderId: this.orderInfo.id,
                newDriverId: row.driverId,
                newVehicleId: row.vehicleId
            }
            const { code } = await this.$axios.post(url, params)
            if (code == 1) {
                this.$message.success('改派成功');
                this.handClose();
                this.ishandle()
            }
            this.loading = false;
        },
        closeWorkOrder() {
            this.$confirm('工单关闭后将无法继续处置，请确认工单已处置完成？', '关闭工单', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let url = "/api/v1/manage/hitchRide/work/close";
                let { code } = await this.$axios.post(url, {
                    workId: this.detailInfo.id
                })
                if (code == 1) {
                    this.$message.success('工单关闭成功')
                    this.getDetailInfo()
                }
            })
        },
        // 订单详情
        async getOrderInfo() {
            let url = '/api/v1/manage/order/hitchRide/info'
            let { code, data } = await this.$axios.get(url, {
                id: this.detailInfo.orderId
            })
            if (code == 1) {
                this.orderInfo = data
                this.refundForm.refundAmount = this.orderInfo.amount || 0;
            }
        },
        async handleRefundSubmit() {
            this.$refs.refundFormRef.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    let url = "/api/v1/manage/hitchRide/work/handling";
                    let params = {
                        workId: this.detailInfo.id,
                        handlingMethod: 3,
                        orderId: this.orderInfo.id,
                        refundType: this.refundForm.refundType,
                        refundAmount: this.refundForm.refundAmount,
                        refundReason: this.refundForm.refundReason,
                    };
                    let { code, data } = await this.$axios.post(url, params)
                    if (code === 1) {
                        this.$message.success('提交成功');
                        this.handClose();
                        this.ishandle()
                    }
                    this.loading = false
                }
            })
        },
    },

};
</script>

<style lang="less" scoped>
.workorderDetail {
    display: flex;
    gap: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color);

    &>.box {
        height: calc(100vh - 200px);
        background: #fff;
        padding: 16px;
        border-radius: 10px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 5px;
        }
    }

    .baseinfo {
        width: 370px;
        flex-shrink: 0;

        .info-header {
            width: 100%;
            line-height: 40px;
            font-size: 16px;
            font-weight: bold;
            user-select: none;
        }

        .status-tag {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
            display: flex;
        }

        :deep(.el-descriptions-item__cell) {
            border-top: 0;
            border-left: 0;
        }

        :deep(.el-descriptions-item__label.is-bordered-label) {
            width: 110px;
            background-color: #FBFBFB;
        }

        :deep(.el-descriptions-item__content) {
            width: 260px;
        }
    }

    .driver-tabs {
        flex: 1;
    }

    /deep/ .el-tabs__content {
        height: calc(100% - 60px);
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &>div {
            width: 100%;
            height: 100%;
        }
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
}
</style>